import * as React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { Row, Button } from "antd";
import "antd/lib/row/style";

import logo from "./404.png";
import "./Vh404.scss";

/**
 * 头部属性声明
 *
 * @interface Vh404Props
 */
export interface Vh404Props {
  /**
   * 返回首页地址
   * 绝对路径，http开头链接
   * 相对路径，react路由
   *
   * @type {string}
   * @memberof Vh404Props
   */
  homePage?: string;
}

type AllProps = Vh404Props & RouteComponentProps;

/**
 * 404页面
 * @class Vh404
 * @extends {React.Component}
 */
class Vh404 extends React.Component<AllProps> {
  /**
   * 返回首页
   *
   * @memberof Vh500
   */
  public onReturn = () => {
    if (this.props.homePage) {
      if (this.props.homePage.startsWith("http")) {
        window.location.href = this.props.homePage;
      } else {
        this.props.history.push({pathname: this.props.homePage});
      }
    } else {
      window.location.href = `${ process.env.REACT_APP_ENV === "pro" ? "https" : "http" }://${ process.env.REACT_APP_ENV !== "pro" ? process.env.REACT_APP_ENV : "" }home.viphrm.com`;
    }
  }

  /**
   * 渲染
   *
   * @returns
   * @memberof Vh404
   */
  public render() {
    return (
      <Row className="vh-exception">
        <img src={ logo } alt="404" />
        <div style={ {marginTop: 32} }>抱歉，页面迷路了</div>
        <div style={ {color: "#999"} }>您访问的页面不存在</div>
        <div style={ {marginTop: 32} }>
          <Button type="primary" shape="round" ghost={ true } onClick={ this.onReturn }>返回首页</Button>
        </div>
      </Row>
    )
  }
}

export default withRouter(Vh404);
